/* eslint-disable no-param-reassign */
import { DashboardModalActions, routeTo } from '@carvana/purchase-helpers';
import { asyncForEach, EventTrackingActions } from '@carvana/purchase-utils';
import * as services from '../services';
import DocumentWizardModal from '../components/document-wizard-modal';
import { SetToastMessage } from '../../../ducks/actions';
import * as types from './action-types';
import { FetchOPDNotifications } from '../../order-placed/components/notifications/ducks/action';

// eslint-disable-next-line no-unused-vars
export const TrackEvent = name => dispatch =>
  EventTrackingActions.TrackEvent({ name });

export const CompleteRequest = (
  { customerId, customerRequestId, vehicleId },
  completeRequest
) => dispatch => {
  if (completeRequest === false) {
    return Promise.resolve();
  }

  return dispatch({
    type: types.COMPLETE_CUSTOMER_REQUEST,
    async payload() {
      return services.completeRequest({
        customerId,
        customerRequestId,
        vehicleId
      });
    }
  });
};

export const CompleteAllPlaidRequests = () => (dispatch, getState) => {
  const {
    orderPlaced: { customerRequest: { requests } } = {}
  } = getState() || {};

  const plaidRequests = requests.filter(request => request.status === 'Open' && request.isPlaidFulfillable);
  return dispatch({
    type: types.COMPLETE_ALL_PLAID_CUSTOMER_REQUESTS,
    async payload() {
      await dispatch(CompleteMultipleRequests(plaidRequests))
        .then(() => dispatch(FetchCustomerRequests()))
        .then(() => dispatch(FetchVerifications()))
        .then(() => dispatch(FetchOPDNotifications()));
    }
  });
}

export const CompleteMultipleRequests = requests => async dispatch =>
  dispatch({
    async payload() {
      await asyncForEach(requests, async request => {
        await dispatch(CompleteRequest(request, true));
      });
    }
  });

export const DocumentUploadDocument = document => dispatch =>
  dispatch({
    type: types.UPLOADING_DOCUMENT,
    async payload() {
      return services.documentUploadDocument(document);
    }
  });

export const DocumentChanged = document => dispatch =>
  dispatch({
    type: types.REQUEST_DOCUMENT_CHANGED,
    payload: document
  });

export const UploadRequestDocuments = requestDocuments => async dispatch =>
  dispatch({
    type: types.UPLOADING_REQUEST_DOCUMENTS,
    async payload() {
      await asyncForEach(requestDocuments, async document => {
        if (!document.upload && !document.image) return;
        await dispatch(DocumentUploadDocument(document)).then(() => {
          dispatch(
            DocumentChanged({
              ...document,
              status: 'Sent'
            })
          );
        });
      });
    }
  });

  export const FetchCustomerRequests = () => (dispatch, getState) => {
    const { vehicle: { vehicleId } = {}, core: { userId } = {} } =
      getState() || {};
    return dispatch({
      type: types.FETCH_CUSTOMER_REQUEST_DOCUMENTS,
      async payload() {
        return services.fetchCustomerRequests(userId, vehicleId);
      }
    });
  };

export const FetchVerifications = () => dispatch =>
  dispatch({
    type: types.VERIFICATIONS_FETCH,
    async payload() {
      return services.fetchVerifications();
    }
  }).catch(err => Promise.reject(err));

export const SetCustomerRequestToast = title => dispatch => {
  const message = {
    type: 'success',
    message: `Your ${title} has been received!`
  };

  return dispatch(SetToastMessage(message));
};

export const HandleCompleteRequest = ({
  requestDocuments,
  request,
  completeRequest
}) => dispatch => {
  const { title } = requestDocuments[0];

  return dispatch({
    type: types.COMPLETING_CUSTOMER_REQUEST,
    async payload() {
      await dispatch(UploadRequestDocuments(requestDocuments))
        .then(() => dispatch(CompleteRequest(request, completeRequest)))
        .then(() => dispatch(TrackEvent('CompletedCustomerRequest')))
        .then(() => dispatch(FetchCustomerRequests()))
        .then(() => dispatch(FetchVerifications()))
        .then(() => dispatch(SetCustomerRequestToast(title)))
        .then(() => dispatch(routeTo(`/order-placed`, 'replace')))
        .then(() => dispatch(FetchOPDNotifications()));
    }
  });
};

export const ResetCustomerRequestState = () => dispatch =>
  dispatch({
    type: types.RESET_CUSTOMER_REQUEST
  });

export const CustomerRequestDocumentSelected = ({
  document,
  selectedFile
}) => dispatch => {
  TrackEvent('CustomerAddsDocument');

  const reader = new FileReader();
  reader.onloadend = () =>
    Promise.resolve(reader.result).then(src =>
      dispatch({
        type: types.CUSTOMER_REQUEST_DOCUMENT_SELECTED,
        payload: {
          ...document,
          id: document.id,
          status: 'Open',
          upload: false,
          image: {
            ...selectedFile,
            name: selectedFile.name,
            type: selectedFile.type,
            size: selectedFile.size,
            fileTooLarge: selectedFile.size / 1024 > 6000,
            src
          }
        }
      })
    );

  reader.readAsDataURL(selectedFile);
};

export const PassedValidation = () => dispatch => {
  dispatch({
    type: types.PASSED_VALIDATION
  });
};

export const VerifiedDocument = payload => dispatch => {
  dispatch({
    type: types.CUSTOMER_VERIFIED_DOCUMENT,
    payload
  });

  DashboardModalActions.CloseModal();
};

export const OpenDocumentWizard = document => dispatch => {
  if (document.status === 'Open' && document.image) {
    dispatch(
      DocumentChanged({
        ...document,
        image: null
      })
    );
  }
  const headerText = 'Uploaded Documents';
  DashboardModalActions.OpenModal({
    headerText,
    ModalChildren: DocumentWizardModal,
    modalProps: {
      documentId: document.id,
      handleSelectedFile: CustomerRequestDocumentSelected,
      verifiedDocument: VerifiedDocument
    }
  });
};
